import { render, staticRenderFns } from "./status.vue?vue&type=template&id=593b006f&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"
import style0 from "./status.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports